import axios from 'axios';
import { logout } from './userActions';

export const getNetworkTrafficInitials = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.get(`/api/nettraffic`, config);

		// const data = {
		// 	NetCols: [
		// 		'Time Stamp',
		// 		'Watcher ID',
		// 		'Source IP',
		// 		'Source Device',
		// 		'Destination IP',
		// 		'Destination Port',
		// 		'Destination Country'
		// 	],
		// 	status: true,
		// 	timeframe: [ '5', '10', '30', '60', '90', '120', 'All' ],
		// 	watchers: [ [ 'V-Watcher200', 'Frontline - DataCenter' ] ]
		// };

		if (data && data.status) {
			return data;
		} else {
			dispatch(logout());
		}
	} catch (err) {
		dispatch(logout());
		return err.response && err.response.data ? err.response.data : err.message;
	}
};

export const getNetworkTrafficData = (formData) => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.post(`/api/nettraffic`, formData, config);

		// const data = {
		// 	NetCols: [
		// 		'Time Stamp',
		// 		'Watcher ID',
		// 		'Source IP',
		// 		'Source Device',
		// 		'Destination IP',
		// 		'Destination Port',
		// 		'Destination Country'
		// 	],
		// 	NetRows: [
		// 		[
		// 			'Fri, 29 Apr 2022 11:55:11 GMT',
		// 			'V-Watcher200',
		// 			'185.125.188.54',
		// 			'Sonicwall',
		// 			'172.16.3.57',
		// 			'41974',
		// 			'United States'
		// 		],
		// 		[
		// 			'Fri, 29 Apr 2022 11:55:11 GMT',
		// 			'V-Watcher200',
		// 			'172.16.3.57',
		// 			'VMware Inc',
		// 			'185.125.188.54',
		// 			'443',
		// 			'United Kingdom'
		// 		]
		// 	],
		// 	WatcherName: [ [ 'V-Watcher200', 'Frontline - DataCenter' ] ],
		// 	status: true,
		// 	timeframe: [ '5', '10', '30', '60', '90', '120', 'All' ],
		// 	watchers: [ [ 'V-Watcher200', 'Frontline - DataCenter' ] ]
		// };

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			dispatch(logout());
		} else {
			return {};
		}
	} catch (err) {
		return {};
	}
};

export const getNetworkTrafficLiveData = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.get(`/api/live`, config);

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			dispatch(logout());
		} else {
			return {};
		}
	} catch (err) {
		return {};
	}
};

export const getNetworkAlertsInitials = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.get(`/api/alerts`, config);
		// const data = {
		// 	NetCols: [ 'Time Stamp', 'Watcher ID', 'Alert' ],
		// 	status: true,
		// 	timeframe: [ '5', '10', '30', '60', '90', '120', 'All' ],
		// 	watchers: [ [ 'V-Watcher200', 'Frontline - DataCenter' ] ]
		// };

		if (data && data.status) {
			return data;
		} else {
			return {};
		}
	} catch (err) {
		return {};
		// 	return err.response && err.response.data ? err.response.data : err.message;
	}
};

export const getNetworkAlertsData = (formData) => async (dispatch) => {
	try {
		// Don't set Content-Type - let axios handle it for FormData
		const { data } = await axios.post(`/api/alerts`, formData);
		// const data = {
		// 	NetCols: [ 'Time Stamp', 'Watcher ID', 'Alert' ],
		// 	NetRows: [
		// 		[
		// 			'Mon, 07 Mar 2022 17:15:49 GMT',
		// 			'V-Watcher200',
		// 			'New internal device detected on the network - (172.16.3.57 / VMware Inc)'
		// 		]
		// 	],
		// 	WatcherName: [ [ 'V-Watcher200', 'Frontline - DataCenter' ] ],
		// 	status: true,
		// 	timeframe: [ '5', '10', '30', '60', '90', '120', 'All' ],
		// 	watchers: [ [ 'V-Watcher200', 'Frontline - DataCenter' ] ]
		// };

		if (data && data.status) {
			return data;
		} else {
			return {};
		}
	} catch (err) {
		return {};
	}
};

export const acknowledgeAlert = (alertId) => async (dispatch) => {
	try {
		console.log('Sending acknowledge request for alertId:', alertId);
		
		if (!alertId) {
			console.error('Alert ID is undefined or null');
			return { status: false, msg: 'Alert ID is required' };
		}
		
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const formData = new FormData();
		formData.append('alertId', alertId);

		const { data } = await axios.post(`/api/acknowledgeAlert`, formData, config);
		console.log('Acknowledge response:', data);

		// Return the data regardless of status - don't logout on status:false
		return data;
	} catch (err) {
		console.error('Error acknowledging alert:', err);
		return { status: false, msg: err.message || 'Error acknowledging alert' };
	}
};

// Bulk acknowledge: the backend /acknowledgeAlert reads a comma-separated
// `alertIds`, so one request clears the whole selection.
export const acknowledgeAlerts = (alertIds, allow = false, note = '') => async (dispatch) => {
	try {
		const ids = (alertIds || []).map((v) => String(v).trim()).filter(Boolean);
		if (ids.length === 0) {
			return { status: false, msg: 'No alerts selected to acknowledge' };
		}
		const config = { headers: { 'Content-Type': 'application/json' } };
		const formData = new FormData();
		formData.append('alertIds', ids.join(','));
		if (allow) formData.append('allow', '1');   // Ack & Allow: also whitelist
		if (note && String(note).trim()) formData.append('note', String(note).trim());
		const { data } = await axios.post(`/api/acknowledgeAlert`, formData, config);
		return data;
	} catch (err) {
		return { status: false, msg: err.message || 'Error acknowledging alerts' };
	}
};

export const acknowledgeAlertByMessage = (timestamp, watcherId, message) => async (dispatch) => {
	try {
		console.log('Acknowledging alert by message data:', { timestamp, watcherId, message });
		
		if (!timestamp || !watcherId || !message) {
			console.error('Missing required data for acknowledging alert by message');
			return { status: false, msg: 'Missing required data' };
		}
		
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const formData = new FormData();
		formData.append('timestamp', timestamp);
		formData.append('watcherId', watcherId);
		formData.append('message', message);

		const { data } = await axios.post(`/api/acknowledgeAlertByMessage`, formData, config);
		console.log('Acknowledge by message response:', data);

		return data;
	} catch (err) {
		console.error('Error acknowledging alert by message:', err);
		return { status: false, msg: err.message || 'Error acknowledging alert' };
	}
};
